import { z } from 'zod';

export const ActionSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('goto_screen'), screen_id: z.string().min(1) }),
  z.object({ type: z.literal('back') }),
  z.object({ type: z.literal('reset') }),
  z.object({ type: z.literal('submit'), form_id: z.string().optional() }),
  z.object({ type: z.literal('set_data'), key: z.string().min(1), value: z.unknown() }),
  z.object({ type: z.literal('webhook'), webhook_id: z.string().min(1) }),
  z.object({ type: z.literal('print_badge') }),
  z.object({ type: z.literal('none') })
]);

export type Action = z.infer<typeof ActionSchema>;